import {
    COVERAGE_TYPE,
    CARE_PATH_CATEGORY_CODE,
    PER_UNIT_MEASURES,
    ESTIMATE_HISTORY_TYPES,
} from '../constants/index';
import formatNumberToCurrency from '../utils/NumberUtil';

/* checks for productDentalID and DentalService to show/hide send estimate's button in estimate and singe estimate page */
export const checkForHidingSendEstimateButton = (
    memberDetails,
    currentSelectedServiceForDisplay,
    hasNoCostShare = false
) => {
    const memberCoverages = memberDetails?.eligibility[0]?.memberHealthCoverage?.coverageType;
    const carepathCategoryCode = currentSelectedServiceForDisplay?.fullCarePath?.coverageTypeCode;

    if (hasNoCostShare) {
        return true;
    }
    if (carepathCategoryCode === 'D') {
        for (let i = 0; i < memberCoverages.length; i++) {
            let findIndex = null;
            if (memberCoverages[i].typeCode.coverageTypeCode === 'D') {
                findIndex = memberCoverages[i];
                const checkProductIDDental = findIndex?.productIdDental;
                const checkForStandAloneDental = checkProductIDDental?.substring(0, 1);
                if (checkForStandAloneDental === 'D') {
                    return true;
                }
            }
        }
    } else if (carepathCategoryCode === CARE_PATH_CATEGORY_CODE.VISION) {
        for (let i = 0; i < memberCoverages.length; i++) {
            let matchingCoverageTypeObj = null;
            if (memberCoverages[i].typeCode.coverageTypeCode === CARE_PATH_CATEGORY_CODE.VISION) {
                matchingCoverageTypeObj = memberCoverages[i];
                const checkisEmbedded = matchingCoverageTypeObj?.isEmbedded;
                const checkForStandAloneVision =
                    matchingCoverageTypeObj?.typeCode?.desc === COVERAGE_TYPE.VISION;
                if (checkisEmbedded !== undefined && checkisEmbedded !== null) {
                    return !checkisEmbedded;
                } else if (checkForStandAloneVision) {
                    return true;
                }
            }
        }
    }

    return false;
};

/**
 * According to PO, for HCA add a condition to bypass our standard hasNoCostShare yellow message and only display the blue disclaimer popup
 */
export const estimateSuppressedByCustomDisclaimer = (serviceNotes, costShare) => {
    const suppressEstimateDisclaimerIDs = ['F', 'I', 'J'];
    const conditionallySuppressEstimateDisclaimerIDs = ['G'];
    const disclaimerWithCostSuppression = serviceNotes
        ? serviceNotes.find(
              (disclaimer) =>
                  suppressEstimateDisclaimerIDs.includes(disclaimer.id) ||
                  (conditionallySuppressEstimateDisclaimerIDs.includes(disclaimer.id) &&
                      costShare == null)
          )
        : false;
    if (disclaimerWithCostSuppression) {
        return true;
    }
    return false;
};

/**
 * Formats name of selected service to be displayed in various places
 * Checks if service name already includes billing code in the name
 * If not, add " - billingCode " to service name
 */
export const getServiceNameToDisplay = (selectedService) => {
    const serviceBillingCode = selectedService?.lineItem?.billingCode?.code;
    const serviceCodeToDisplay = selectedService?.name?.includes(serviceBillingCode)
        ? ''
        : ` - ${serviceBillingCode}`;

    return `${selectedService?.name}${serviceCodeToDisplay}`;
};

/**
 * Uses carePathServiceTypes to identify which unit measure message to be shown on single estimates page.
 */
export const unitMeasureMessage = (carePathServiceTypes) => {
    let text = '';
    if (carePathServiceTypes) {
        if (carePathServiceTypes?.includes(PER_UNIT_MEASURES.ambulance)) {
            text = 'per mile';
        } else if (carePathServiceTypes?.includes(PER_UNIT_MEASURES.perUnit)) {
            text = 'per unit';
        }
    }
    return text;
};

export const unitMessage = (carePathServiceTypes) => {
    return showPerUnitMeasure(carePathServiceTypes) ? ' / unit' : '';
};

export const showPerUnitMeasure = (carePathServiceTypes) => {
    return carePathServiceTypes?.includes(PER_UNIT_MEASURES.perUnit);
};

/**
 * Identifies the unit measure message verbiage to be used in info modal.
 */
export const unitMeasureInfoVerbiage = (carePathServiceTypes) => {
    return (
        <div>
            <p>
                {`The estimated cost is based on 1 ${
                    carePathServiceTypes?.includes('Ambulance') ? 'mile' : 'unit'
                }. The actual cost will vary based on the number of ${
                    carePathServiceTypes?.includes('Ambulance') ? 'miles' : 'units'
                } billed.`}
            </p>
        </div>
    );
};

export const showRentalDuration = (serviceInfo) => {
    const modifierValue = serviceInfo?.lineItem?.codeModifier;
    return (
        modifierValue == ESTIMATE_HISTORY_TYPES.rental &&
        serviceInfo?.carePathStep?.stepDurationDays
    );
};

export const rentalDurationText = (serviceInfo) => {
    return serviceInfo?.carePathStep?.stepDurationDays == 1 ? 'per day' : 'per month';
};

export const rentalPeriodText = (serviceInfo) => {
    return serviceInfo?.carePathStep?.stepDurationDays == 1 ? 'daily' : 'monthly';
};

/** Returns rate source for an estimate based on the matching coverage line in pop config */
export const getRateSourceForEstimate = (estimate, popConfig) => {
    return popConfig.categoryList.find((coverageLine) => {
        return coverageLine.categoryName.toUpperCase() == estimate.coverageType.toUpperCase();
    }).config.rateSource;
};

export const estimatedCostDisplaySingle = (singleEstimateResponse, costShare) => {
    if (singleEstimateResponse && (costShare?.insurancePays || costShare?.insurancePays == 0)) {
        return '- ' + formatNumberToCurrency(costShare?.insurancePays, costShare?.outOfPocket);
    } else {
        return '- $ --';
    }
};
